// extracted by mini-css-extract-plugin
var _1 = "ra-logo";
var _2 = "ra-logo-image";
var _3 = "ra-logo-link";
var _4 = "ra-logo-page-title";
var _5 = "ra-logo-black";
var _6 = "ra-logo-white";
var _7 = "ra-logo-default";
var _8 = "ra-logo-initial";
var _9 = "ra-logo-square";
export { _1 as "logoCls", _2 as "logoImageCls", _3 as "logoLinkCls", _4 as "logoPageTitleCls", _5 as "logoThemeBlackCls", _6 as "logoThemeWhiteCls", _7 as "logoTypeDefaultCls", _8 as "logoTypeInitialsCls", _9 as "logoTypeSquareCls" }
